<template>
    <div>

        <div class="row" v-if="gotData">
            <div class="col" v-if="Object.keys(dailyUsage.labels).length > 0">
                <div class="row">
                    <div class="col" v-if="endDate">
                        <h5>Daily Usage for {{ endDate | moment('MMMM YYYY') }}</h5>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="sau-bx bx-pad">
                            <canvas id="usage" style="height:300px; width:100%;" class="lazy-double-bar-graph" :data-billType="billType" :data-points="JSON.stringify(dailyUsage)"></canvas>
                        </div>
                        <p class="sau-font sm text-center">
                            <i class="fas fa-exclamation-triangle sau-font-color blue"></i>
                            <span class="sau-font-bold">Important</span> -
                            <a v-b-popover.hover.top.html="switched" title="Your Data Transfer Graphs are switched">Your Data Transfer Graphs are switched!</a>
                        </p>
                    </div>
                </div>
            </div>
            <div v-else class="col">

                <sau-apiro-response type="message" support="true">
                    <template slot="message">No daily usage graphs available.</template>
                    <template slot="details">
                        <p>We can't retrieve your bandwidth data at the moment. However support can quickly attend to this.</p>
                    </template>
                </sau-apiro-response>

            </div>
        </div>
        <div class="row" v-else>
            <div class="col">
                <div class="row">
                    <div class="col">
                        <sau-loading>
                            <template slot="message">Fetching Daily Usage</template>
                        </sau-loading>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import jsFunctions from '@js/store/jqueryFunctions';
export default {
    mixins: [jsFunctions],
    data() {
        return {
            endDate: '',
            switched:  `<div class="sau-font xs">The following graphs show the direction of data transfer in the opposite way to what you might expect:<br /><br />
                        <span class="bold">In</span> - From your service to our switch.<br />
                        <span class="bold">Out</span> - From our switch to your service.</div>`,
            dailyUsage: {
                labels: [],
                points: {
                    in: [],
                    out: []
                }
            },
            billType: 'Quota'
        }
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            this.getCurrentBandwidthUsage().then(response => {
                if(response.data.status = 'success') {
                    this.endDate = response.data.endDate;
                    this.dailyUsage = response.data.current;
                    this.billType = response.data.type;
                    this.$nextTick(() => {
                        this.registerAnimateOnView();
                    });
                }
            });
        },
    },
    computed: {
    }
}
</script>
<style>
</style>
